import React from 'react';

import moment from 'moment-timezone';
import _ from 'lodash';

import { orderStatus } from '../../utils/constant';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import request from '../../utils/request';
import FieldGuide from '../../form/fields/common/fieldGuide';
import Tooltip from '../../tooltip';
import Tag from '../../common/tags';
import { MessageOrderLocked } from './css';

const getFinalStatus = statusOrder => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { status }
  } = localizedStrings;

  let finalStatus;
  let statusId;
  if (statusOrder === orderStatus.incomplete) {
    finalStatus = status.incomplete;
    statusId = 'incomplete';
  } else if (statusOrder === orderStatus.pendingValidation) {
    finalStatus = status.pendingValidation;
    statusId = 'pendingValidation';
  } else if (statusOrder === orderStatus.waitingOnSales) {
    finalStatus = status.waitingOnSales;
    statusId = 'waitingOnSales';
  } else if (statusOrder === orderStatus.waitingOnCredit) {
    finalStatus = status.waitingOnCreditCheck;
    statusId = 'waitingOnCredit';
  } else if (statusOrder === orderStatus.contractSent) {
    finalStatus = status.contractSent;
    statusId = 'contractSent';
  } else if (statusOrder === orderStatus.contractSigned) {
    finalStatus = status.contractSigned;
    statusId = 'contractSigned';
  } else if (statusOrder === orderStatus.contractExpired) {
    finalStatus = status.contractExpired;
    statusId = 'contractExpired';
  } else if (statusOrder === orderStatus.orderCanceled) {
    finalStatus = status.orderCanceled;
    statusId = 'orderCanceled';
  } else if (statusOrder === orderStatus.orderPlaced) {
    finalStatus = status.orderPlaced;
    statusId = 'orderPlaced';
  } else if (statusOrder === orderStatus.orderActivated) {
    finalStatus = status.orderActivated;
    statusId = 'orderActivated';
  } else if (statusOrder === orderStatus.orderShipped) {
    finalStatus = status.orderShipped;
    statusId = 'orderShipped';
  } else if (statusOrder === orderStatus.orderCompleted) {
    finalStatus = status.orderCompleted;
    statusId = 'orderCompleted';
  }

  return { finalStatus, statusId };
};

export const getStatus = ({ status }) => {
  const localizedStrings = useLocalizedStringsContext();

  const {
    srtDashboard: { statusToolTipMessageIoT }
  } = localizedStrings;

  const { statusId, finalStatus } = getFinalStatus(status);
  const getToolTip = () => {
    const message = _.get(statusToolTipMessageIoT, status, '');
    return (
      <div className="responsive-table__status">
        {finalStatus}
        <div className="responsive-table__status-guide">
          <FieldGuide tooltip={message} />
        </div>
      </div>
    );
  };
  return { statusId, finalStatus, statusToolTip: getToolTip() };
};

export const getMessage = (data, callback) => {
  const { id, isContractResend, isOrderReturned, isLockedBy } = data;
  const { email } = request.getProfile();
  const localizedStrings = useLocalizedStringsContext();
  const {
    sovTableMessages: { resendContract, returnOrder }
  } = localizedStrings.ORDERS;
  return (
    <div className="responsive-table__messages">
      {isContractResend && (
        <Tag
          orderId={id}
          tagKey="isContractResend"
          tagLabel={resendContract}
          callback={callback}
        />
      )}
      {isOrderReturned && (
        <Tag
          orderId={id}
          tagKey="isOrderReturned"
          tagLabel={returnOrder}
          callback={callback}
        />
      )}
      {isLockedBy && isLockedBy !== email && (
        <MessageOrderLocked>{`This order is being currently worked on by ${isLockedBy}`}</MessageOrderLocked>
      )}
    </div>
  );
};

export const getLastComment = data => {
  const lastComment = _.get(data, 'orderComments.0.text', '');
  if (lastComment.length > 50) {
    let shortenedLastComment = lastComment.substring(0, 47);
    shortenedLastComment += '...';
    return (
      <>
        <Tooltip
          id={_.get(data, 'orderComments.0.id', '')}
          message={lastComment}
          icon="fa-info-circle"
        >
          {`${shortenedLastComment}`}
        </Tooltip>
      </>
    );
  }
  return lastComment;
};

export const getLocalFormattedTime = (date, format = 'MM/DD/YYYY, hh:mm A') => {
  const localZone = moment.tz.guess();

  return `${moment
    .utc(date)
    .local()
    .format(format)} ${moment.tz.zone(localZone).abbr(360)}`;
};

export const getAssignee = orderAssignedTo =>
  orderAssignedTo &&
  `${_.get(orderAssignedTo, 'first_name', '')} ${_.get(
    orderAssignedTo,
    'last_name',
    ''
  )}`;
